import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { later } from '@ember/runloop';
import { isEmpty } from '@ember/utils';
import WalletApi from 'mewe/api/wallet-api';

export default class WalletConfirm extends Component {
  @service dynamicDialogs;
  @service account;
  @service turnkey;

  @tracked token = '';
  @tracked showTokenInput = false;
  @tracked isResendDisabled = true;
  @tracked tokenTime = new Date().getTime();

  otpId = null;

  get email() {
    return this.account.activeUser.primaryEmail;
  }

  get amount() {
    return this.args.amount;
  }

  get toWalletAddress() {
    return this.args.walletAddress;
  }
  
  get fromWalletAddress() {
    return this.account.walletData.walletAddress;
  }

  get isConfirmDisabled() {
    return isEmpty(this.token) && !this.turnkey.isAuthenticated;
  }

  @action
  async checkSession() {
    if (!this.turnkey.isAuthenticated) {
      this.showTokenInput = true;
      const response = await WalletApi.sendOtp();
      this.otpId = response.otpId;
    } 
  }

  @action
  confirmTransaction() {
    this.args.onConfirm(this.otpId, this.token);
  }

  @action
  async resetToken() {
    this.isResendDisabled = false;
    this.tokenTime = new Date().getTime();
  }

  @action
  async resendToken() {
    try {
      const response = await WalletApi.sendOtp();
      this.otpId = response.otpId;
      this.isResendDisabled = true;
    } catch (error) {
      this.dynamicDialogs.openDialog('wallet-failed-dialog', {
        title: __('Failed to send token'),
        message1: __('We were unable to send you a token. Please try again.'),
        message2: __('If the problem persists, please contact support.'),
      });
    }
  } 

} 